module.exports = __webpack_public_path__ + "img/so.b6907d05.svg";